import { useApps } from '@auth/useApps'
import { AppPermission } from '@shared/permissions'
import NewSpaceChip from './NewSpaceChip'

const NewSpaceNavChip: React.FC = () => {
  const [hasAppPermission] = useApps()
  const hasNewSpace = hasAppPermission('spacesApp', AppPermission.SpacesAppBrowseNew)
  return hasNewSpace ? <NewSpaceChip size="small" /> : null
}

export default NewSpaceNavChip
